import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getGameList } from "@/api/game";
export default {
  name: "GameSelect",
  props: {
    value: {
      default: 0
    },
    data_no_all: {
      default: 1
    },
    pname: {
      default: ""
    }
  },
  data: function data() {
    return {
      game_id: this.value,
      gameList: {}
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.game_id = val;
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getGameListFn();
            if (_this.game_id != "") {
              _this.selectGame();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // watch: {
  //     pname(val, oldVal) {
  //         //普通的watch监听
  //         console.log("a: " + val, oldVal);
  //         this.getGameListFn();
  //     },
  // },
  methods: {
    selectGame: function selectGame() {
      this.$emit("input", this.game_id);
      this.$emit("change", this.game_id);
    },
    getGameListFn: function getGameListFn() {
      var _this2 = this;
      var data = {
        data_no_all: this.data_no_all,
        pname: this.pname
      };
      getGameList(data).then(function (res) {
        if (res.code == 0) {
          _this2.gameList = res.data.games;
        }
      });
    }
  }
};